

 <div class="conversation-list-container">
  <!-- Header -->
  <header class="page-header">
    <h2>Conversations</h2>
  </header>

  <!-- Filters Card -->
  <mat-card class="filters-card">
    <mat-card-content>
      <div class="filters">
        <mat-form-field appearance="outline">
          <mat-label>Start Date</mat-label>
          <input matInput [matDatepicker]="picker1" [(ngModel)]="startDate" (ngModelChange)="onDateRangeChange()" />
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>End Date</mat-label>
          <input matInput [matDatepicker]="picker2" [(ngModel)]="endDate" (ngModelChange)="onDateRangeChange()" />
          <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
          <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" class="search-bar">
          <mat-label>Search Conversations</mat-label>
          <input matInput [formControl]="searchControl" placeholder="Search by phone number" />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- Conversation List -->
  <div class="list-wrapper">
    <mat-spinner diameter="50" *ngIf="!(filteredConversations$ | async)" class="loading-spinner"></mat-spinner>

    <mat-list class="conversation-list" *ngIf="filteredConversations$ | async as conversations">
      <mat-list-item
        class="conversation-item"
        *ngFor="let conversation of conversations"
        (click)="onConversationClick(conversation.id)"
      >
        <div matListItemTitle class="conversation-title">
          #{{ conversation.id }}
        </div>
        <div matListItemLine class="last-message" *ngIf="conversation.lastMessage">
          Last Message: {{ conversation.lastMessage | date:'medium' }}
        </div>
        <div matListItemLine class="no-message-placeholder" *ngIf="!conversation.lastMessage">
          No recent messages
        </div>

        <!-- <mat-icon  matListItemMeta>chevron_right</mat-icon> -->
         <mat-icon >search</mat-icon>
      </mat-list-item>
    </mat-list>

    <div class="empty-state" *ngIf="(filteredConversations$ | async)?.length === 0">
      No conversations found in the selected date range.
    </div>
  </div>
</div>